// Texty stránky Kontakt (contactPage.js). Handover design_handoff_kontakt.
import { NBSP } from '../../modules/money.js';

export default {
  h1: 'Jsme tu pro vás',
  perex: 'Tým Jipos vyřídí vaši objednávku, reklamaci i' + NBSP + 'dotaz k' + NBSP + 'nářadí.',
  hoursNote: 'Na e-mail odpovídáme obvykle do pár hodin',
  faqTitle: 'Nejčastější dotazy vyřešíte hned',
  faqHint: 'Bez čekání, online',
  tipTitle: 'Odkazy k vaší objednávce',
  tipText:
    'Odkazy propojené přímo s vaší objednávkou najdete v e-mailu s potvrzením objednávky, takže nemusíte zadávat žádné údaje.',
  reach: 'Ozvěte se nám',
  /** fallback nadpisu karty prodejny, když ho obsah administrace nenese */
  storeFallback: 'Prodejna nářadí Bílina',
  openNow: 'teď otevřeno',
  navigate: 'Navigovat na prodejnu',
  storeMore: 'Co u nás najdete',
  billing: 'Fakturační údaje',
  team: 'Tým Jipos',
  teamHint: 'Na koho se obrátit napřímo',
  gallery: 'Podívejte se k nám na prodejnu',
  video: 'Videoprohlídka',
  videoCap: 'Prodejna Jipos · Bílina',
  map: 'Kde nás najdete',
  mapCta: 'Otevřít v mapách',
  heroAlt: 'Tým Jipos před prodejnou v Bílině',
  /** fallback drobečků, když nativní `.breadcrumbs` chybí */
  crumbFallback: 'Kontakt',
  galleryAlt: 'Prodejna Jipos v Bílině',
  /** tři dlaždice „Nejčastější dotazy" (4. je FAQ.tileTitle/tileSub z common.js) */
  tiles: [
    { title: 'Stav objednávky', sub: 'Sledovat zásilku' },
    { title: 'Reklamace', sub: 'Založit online' },
    { title: 'Vrácení zboží', sub: 'Do 14 dnů od převzetí' },
  ],
  // Čtení OBSAHU administrace stránky kontaktů (odkazy a nadpisy karet)
  /** dlaždice: stav objednávky · reklamace · vrácení · časté dotazy */
  tileRe: [/stav|objedn/i, /reklam/i, /vr[áa]t|odstoup|14/i, /caste-dotazy|[čc]ast[ée] dotazy|faq/i],
  /** nadpisy karet: e-shop · prodejna · fakturační údaje */
  cardShopRe: /e-?shop/i,
  cardStoreRe: /prodejn/i,
  cardBillingRe: /faktura|[úu]daj/i,
  /** popisek IČ z administrace → „IČO" */
  idLabel: (label) => (label === 'IČ' ? 'IČO' : label),
};
